// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"EquipmentActionIcon_action-btn__yKIT2","view-dashboard":"EquipmentActionIcon_view-dashboard__S9kxW"};